import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, catchError, from, map, merge, mergeMap } from 'rxjs';

import { TicketsBoardService } from '../../services/tickets-board.service';
import { DocsActions } from '../docs/docs.actions';
import { WorkflowActions } from './workflow.actions';

// Only the docs the Home workflow summaries actually read — far fewer calls
// than the legacy store's load-everything warm-up.
const WORKFLOW_DOC_KEYS = ['define.definition', 'db-design.main', 'marketplace.state'] as const;

const warmProject$ = createEffect(
  (actions$ = inject(Actions), svc = inject(TicketsBoardService)) =>
    actions$.pipe(
      ofType(WorkflowActions.warmProject),
      mergeMap(({ projectId }) => {
        const pid = String(projectId ?? '').trim();
        if (!pid) return EMPTY;
        const immediate = WORKFLOW_DOC_KEYS.map((key) => DocsActions.loadDoc({ projectId: pid, key }));
        // Tickets board is persisted via TicketsBoardService, not machine-docs.
        const board$ = from(svc.find({ where: { projectId: pid, key: 'tickets.board' } as any })).pipe(
          map((res) => {
            const existing = ((res?.data ?? []) as any[])[0] ?? null;
            const columns = Array.isArray(existing?.columns) ? existing.columns : [];
            return WorkflowActions.boardLoaded({ columns });
          }),
          catchError(() => EMPTY)
        );
        return merge(from(immediate), board$);
      })
    ),
  { functional: true }
);

export const workflowEffects = { warmProject$ };
